// "Top Risks Requiring Action" on the Security Insights dashboard. Only real gaps qualify: a
// control that is Not Implemented or Partial. Not Assessed (no evidence), Not Applicable and
// Implemented never do — a missing observation is not a risk to act on. Critical and High both
// qualify, Critical first, then Not Implemented before Partial; otherwise the server's order is kept.

const SEVERITY_RANK = { Critical: 0, High: 1 };
const STATUS_RANK = { NotImplemented: 0, Partial: 1 };

export function selectTopRisks(controls, limit = 6) {
  return (controls || [])
    .map((c, index) => ({ c, index }))
    .filter(({ c }) => c.riskLevel in SEVERITY_RANK && c.status in STATUS_RANK)
    .sort((a, b) =>
      SEVERITY_RANK[a.c.riskLevel] - SEVERITY_RANK[b.c.riskLevel]
      || STATUS_RANK[a.c.status] - STATUS_RANK[b.c.status]
      || a.index - b.index)
    .slice(0, limit)
    .map(({ c }) => c);
}
